export default "__VITE_ASSET__CcQq4jMw__"